import {
  Card,
  CardContent,
  Link,
  LinkProps,
  Stack,
  SvgIconProps,
  Typography,
} from '@mui/material'

import { Organism } from '@/core/architecture'

export type DeactivationBoxProps = {
  type?: 'info' | 'error'
  Icon: (props: SvgIconProps) => JSX.Element
  title: string
  description: string
  actions?: LinkProps[]
}

export const DeactivationBox: Organism<DeactivationBoxProps> = ({
  type = 'info',
  Icon,
  title,
  description,
  actions,
}) => (
  <Card elevation={0} sx={{ borderRadius: 2 }}>
    <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Icon
            fontSize="small"
            sx={{ color: type === 'error' ? 'error.main' : 'grey.600' }}
          />
          <Typography
            variant="subtitle1"
            sx={{ color: type === 'error' ? 'error.main' : 'grey.600' }}
          >
            {title}
          </Typography>
        </Stack>
        <Typography variant="caption">{description}</Typography>
        {!!actions?.length && (
          <Stack direction="row" spacing={4}>
            {actions.map((action, index) => (
              <Link
                {...action}
                key={index}
                variant="caption"
                color="primary.main"
              />
            ))}
          </Stack>
        )}
      </Stack>
    </CardContent>
  </Card>
)
